import React from 'react';
import { AnalyticsPromos } from '../utils/analytics';

type Promo = {
    id:number,
    url:string,
    image_url:string,
    target:string,
    name:string,
};

type Props = {
    promo:Promo
};

type State = {
    analytics_setup:boolean
};

class PromoWide extends React.PureComponent<Props, State> {
    private ref:React.RefObject<HTMLAnchorElement> = React.createRef();

    constructor(props:Props) {
        super(props);

        this.onClick = this.onClick.bind(this);
        this.state = { analytics_setup: false };
    }

    componentDidMount() {
        this.setup();
    }
    
    componentDidUpdate() {
        this.setup();
    }

    setup() {
        if (!this.ref.current || this.state.analytics_setup) return;

        this.setState({ analytics_setup: true });
        const { promo } = this.props;
        
        setTimeout(() => {
            AnalyticsPromos.observe('promo_wide', promo.id, promo.name, this.ref.current);
        }, 1500);
    }

    onClick(event:React.MouseEvent<HTMLElement>) {
        const { promo } = this.props;
        const openInNewWindow:boolean = promo.target !== '_self' || event.altKey || event.ctrlKey || event.shiftKey;

        AnalyticsPromos.trackClick('promo_wide', promo.id, promo.name, openInNewWindow ? null : () => {
            document.location = promo.url;
        });

        if (!openInNewWindow) event.preventDefault();
    }

    render() {
        const { promo } = this.props;

        if (!promo) {
            return null;
        }

        return <a href={promo.url || '#'} target={promo.target} ref={this.ref} onClick={this.onClick} className='o-ad-w-100'>
            <img src={promo.image_url} alt={promo.name} />
        </a>;
    }
}

export default PromoWide;